@if (loading) {
  <div class="loading loading-contained">
    <div class="loader">Loading...</div>
  </div>
}

@if (sharedDataService.subscriptionType != "premium") {
  <p class="mb-4">
    Email Integration in Client Hub is available to Premium-level subscribers.
    Please upgrade your subscription to Premium level to access this feature
  </p>
} @else if (
  (inboxState == null && loading == false) || inboxState == "deleted"
) {
  <i class="tio-email" style="font-size: 64px; opacity: 0.3"></i>
  <h4 class="mb-2 mt-4" style="color: #000">Connect your email</h4>
  <p class="mb-4">
    Once you've connected your email account, you'll be <br />able to receive
    emails, convert emails to jobs and more.
  </p>
  <div class="buttons mt-5">
    <div class="dropdown" dropdown style="display: inline-block">
      <a data-toggle="dropdown" dropdownToggle class="btn btn-primary me-3"
        >Connect account <i class="feather chevron-down"></i
      ></a>
      <ul
        class="dropdown-menu"
        role="menu"
        *dropdownMenu
        aria-labelledby="button-basic"
        style="width: 95%"
      >
        <li (click)="getAuthUrl('google')" role="menuitem">
          <a class="dropdown-item">Google</a>
        </li>
        <li (click)="getAuthUrl('outlook')" role="menuitem">
          <a class="dropdown-item">Microsoft</a>
        </li>
      </ul>
    </div>
  </div>
} @else if (inboxState == "syncing" && loading == false) {
  <i class="tio-sync" style="font-size: 64px; opacity: 0.3"></i>
  <h4 class="mb-2 mt-4" style="color: #000">Syncing your emails</h4>
  <p class="mb-4">
    We are synchronizing your email box. This takes at least a few minutes.<br />
    Please return to this page in a few minutes and hit Refresh on your browser
    to see if the sync process is complete.
  </p>
} @else if (inboxState == "connected") {
  <i class="tio-new_email" style="font-size: 64px; opacity: 0.3"></i>
  <h4 class="mb-2 mt-4" style="color: #000">Already connected</h4>
  <p class="mb-4">
    Your email account is already connected, click the button bellow to see your
    inbox.
  </p>
  <a routerLink="/practice/email" class="btn btn-primary">Go to your Inbox</a>
} @else if (inboxState == "auth_error" && loading == false) {
  <div class="text-center">
    <i class="tio-sync" style="font-size: 64px; opacity: 0.3"></i>
    <h4 class="mb-2 mt-4" style="color: #000">Auth Error</h4>
    <p class="mb-4">
      Your email connection has failed. Please check out our help center for more
      information and then click on Retry Connection.
    </p>

    <button class="btn btn-primary" (click)="retryConnection()">
      Retry Connection
    </button>
  </div>
}
